import React from "react";
import { Routes, Route } from "react-router-dom";

// Core Pages
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";

// New Pages
import CreatePage from "./pages/CreatePage";
import LibraryPage from "./pages/LibraryPage";
import AlbumsPage from "./pages/AlbumsPage";
import DiscoverPage from "./pages/DiscoverPage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";
import RegisterPage from "./pages/RegisterPage";
import OnboardingPage from "./pages/OnboardingPage";
import LandingPage from "./pages/LandingPage";
import EntryPage from "./pages/EntryPage";
import EventsPage from "./pages/EventsPage";
import AllEventsPage from "./pages/AllEventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import EventSubmissionsPage from "./pages/EventSubmissionsPage";
import BadgesPage from "./pages/BadgesPage";
import PublishedContentPage from "./pages/PublishedContentPage";
import ContentPage from "./pages/ContentPage";
import TagPage from "./pages/TagPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import AllCreatorsPage from "./pages/AllCreatorsPage";
import FilmDirectorPage from "./pages/FilmDirectorPage";
import BrandAndMarketingPage from "./pages/BrandAndMarketingPage";
import EffectDisplayPage from "./pages/EffectDisplayPage";

// Route Guards
import AuthRoute from "./components/AuthRoute";
import PrivateRoute from "./components/PrivateRoute";
import ProPage from "./pages/ProPage";

import "./index.css";

import BuyFluxPage from "./pages/BuyFluxPage";
import AIToolsPage from "./pages/AIToolsPage";
import UploadsPage from "./pages/UploadsPage";
import InteractiveEditingPage from "./pages/InteractiveEditingPage";
import EditingChatsPage from "./pages/EditingChatsPage";
import NotificationsPage from "./pages/NotificationsPage";

function App() {
  return (
    <Routes>
      {/* Public routes that should not have the main nav */}
      <Route>
        <Route path="/" element={<EntryPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" new-key-being-added={<RegisterPage />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/content/:contentId" element={<ContentPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/tos" element={<TermsOfServicePage />} />
      </Route>
      {/* Onboarding is a special case: it's a private route but doesn't use the main AppLayout */}
      <Route element={<PrivateRoute />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
      </Route>

      {/* Routes with the main app layout */}
      <Route
        path="/home"
        element={
          <AuthRoute>
            <DashboardPage />
          </AuthRoute>
        }
      />
              
<Route
path="/tags/:tagName"        element={
          <AuthRoute>
            <TagPage />
          </AuthRoute>
        }
      />
      <Route
        path="/creators"
        element={
          <AuthRoute>
            <AllCreatorsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/uploads"
        element={
          <AuthRoute>
            <UploadsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/albums/:albumId"
        element={
          <AuthRoute>
            <AlbumsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/badges"
        element={
          <AuthRoute>
            <BadgesPage />
          </AuthRoute>
        }
      />
      <Route
        path="/ai-tools"
        element={
          <AuthRoute>
            <AIToolsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/create"
        element={
          <AuthRoute>
            <CreatePage />
          </AuthRoute>
        }
      />
      <Route
        path="/library"
        element={
          <AuthRoute>
            <LibraryPage />
          </AuthRoute>
        }
      />
      <Route
        path="/buy"
        element={
          <AuthRoute>
            <BuyFluxPage />
          </AuthRoute>
        }
      />
      <Route
        path="/discover"
        element={
          <AuthRoute>
            <DiscoverPage />
          </AuthRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <AuthRoute>
            <ProfilePage />
          </AuthRoute>
        }
      />
      <Route
        path="/profile/:userId"
        element={
          <AuthRoute>
            <ProfilePage />
          </AuthRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <AuthRoute>
            <SettingsPage/>
          </AuthRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <AuthRoute>
            <NotificationsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/events"
        element={
          <AuthRoute>
            <EventsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/events/:type"
        element={
          <AuthRoute>
            <AllEventsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/events/detail/:id"
        element={
          <AuthRoute>
            <EventDetailPage />
          </AuthRoute>
        }
      />
      <Route
        path="/events/:id/submissions"
        element={
          <AuthRoute>
            <EventSubmissionsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/pro"
        element={
          <AuthRoute>
            <ProPage />
          </AuthRoute>
        }
      />
      <Route
        path="/published-content"
        element={
          <AuthRoute>
            <PublishedContentPage />
          </AuthRoute>
        }
      />
      <Route
        path="/interactive-editing/:id"
        element={
          <AuthRoute>
            <InteractiveEditingPage />
          </AuthRoute>
        }
      />
      <Route
        path="/editing-chats"
        element={
          <AuthRoute>
            <EditingChatsPage />
          </AuthRoute>
        }
      />
      <Route
        path="/film-director"
        element={
          <AuthRoute>
            <FilmDirectorPage />
          </AuthRoute>
        }
      />
      <Route
        path="/brand-marketing"
        element={
          <AuthRoute>
            <BrandAndMarketingPage />
          </AuthRoute>
        }
      />
      <Route path="/effects/:effectId" element={<EffectDisplayPage />} />
    </Routes>
  );
}

export default App;